import React, { useState } from 'react';
import StationIcon from '@mui/icons-material/Tv';

import { MenuAnchor } from '@paragon/client-tools';
import { Station } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { useStationBreadcrumbs } from '../../../selectors/breadcrumbsSelector';
import { useAppSelector } from '../../hooks';
import { Breadcrumbs } from '../Breadcrumbs';
import { StationMenu } from '../menus/StationMenu';
import { BaseCard } from './BaseCard';

export function StationCard(props: { station: Station; lineGuid?: string; onMultipleLines?: boolean }) {
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  const breadcrumbs = useStationBreadcrumbs(props.lineGuid, props.station.guid);

  const url = props.lineGuid
    ? `/lines/${props.lineGuid}/stations/${props.station.guid}`
    : `/stations/${props.station.guid}`;

  const subheader = props.onMultipleLines ? (
    'On multiple lines'
  ) : props.lineGuid && breadcrumbs.length > 0 ? (
    <Breadcrumbs omitSelf disableLinks crumbs={breadcrumbs} />
  ) : undefined;

  return (
    <BaseCard
      avatar={<StationIcon />}
      title={props.station.name}
      subheader={subheader}
      linkTo={url}
      menu={
        isSupervisor ? (
          <StationMenu
            station={props.station}
            lineGuid={props.lineGuid}
            anchor={menuAnchor}
            onClose={() => setMenuAnchor(null)}
          />
        ) : undefined
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
